export default __webpack_public_path__ + "static/media/tulip.5fb62af7.svg";